import { Documents } from '@/features/Documents/Documents';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const documentsSearchSchema = z.object({
    filter: z.string().optional().catch(undefined),
    page: z.number().int().positive().optional().catch(undefined),
    documentId: z.number().int().positive().optional().catch(undefined),
    projectId: z.number().optional(),
    aircraftId: z.number().optional(),
    isProjectView: z.boolean().optional(),
    isAircraftView: z.boolean().optional(),
    isAssetView: z.boolean().optional(),
    assetId: z.number().optional(),
    collectionId: z.number().optional(),
});

export const Route = createFileRoute('/documents/')({
    component: Documents,
    validateSearch: documentsSearchSchema,
});
